import { render, staticRenderFns } from "./CertificateLinkCompanyDialog.vue?vue&type=template&id=1bc65295&scoped=true"
import script from "./CertificateLinkCompanyDialog.vue?vue&type=script&lang=js"
export * from "./CertificateLinkCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc65295",
  null
  
)

export default component.exports